import { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { useIsCompactMode } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

interface Props {
  children: React.ReactNode;
}

export const StickyTopBar = ({ children }: Props) => {
  const isCompactMode = useIsCompactMode();
  const ref = useRef<HTMLDivElement>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => setIsStuck(entry.intersectionRatio < 1), {
      threshold: [1],
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} css={[!isCompactMode && topBarStyles.filters, isStuck && topBarStyles.stuckShadow]}>
      {children}
    </div>
  );
};

const topBarStyles = {
  filters: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
    position: sticky;
    top: -1px;
    background: ${theme.colors.white};
    z-index: ${theme.zIndex.sticky};
    padding-bottom: ${theme.spacing(3)};
  `,
  stuckShadow: css`
    box-shadow: 0px 4px 8px 0px rgba(0, 33, 82, 0.15);
    clip-path: inset(0 0 -8px 0);
  `,
};
